/**
 * Text content, copy, and SEO strings used across the site
 */

export const SEO_DEFAULT_KEYWORDS =
  'AI Engineer, Machine Learning, NLP, Computer Vision, LLMs, Python Developer, Azure Specialist, Microsoft 365, System Operations, Dublin Ireland, Freelance AI Developer, RAG, LangChain, Deep Learning, TensorFlow, PyTorch, Cloud Solutions, Data Engineering';

export const SEO_KNOWS_ABOUT = [
  'Artificial Intelligence',
  'Machine Learning',
  'Natural Language Processing',
  'Computer Vision',
  'Large Language Models',
  'Python Programming',
  'Microsoft Azure',
  'Microsoft 365',
  'System Operations',
  'Cloud Computing',
  'Data Engineering',
] as const;

export const PLACEHOLDER_EMAIL = 'your@email.com';
